import { useTranslation } from 'react-i18next';
import i18n from '@src/i18n';
import type en from '@src/i18n/locales/en.json';
import { premiumOffer } from './offer';
import { usePremiumOffer } from './PremiumOfferProvider';

export type PremiumPageCopy = typeof en.premiumPage;
export function usePremiumPageCopy(): PremiumPageCopy {
  const { t } = useTranslation();
  const offer = usePremiumOffer();
  return t('premiumPage', { returnObjects: true, price: offer.formattedPrice }) as PremiumPageCopy;
}
export function getPremiumPageCopy(): PremiumPageCopy {
  return i18n.t('premiumPage', { returnObjects: true, price: premiumOffer(i18n.language).formattedPrice }) as PremiumPageCopy;
}
